import { mapGetters } from 'vuex';
import { throttle } from '@/utils';
import event from '@/utils/bus';

const throttleTime = 50; // 滚动记录触发时间，越小越精确，越大对性能影响越小
const bottomDistance = 40; // 距底部多少距离算浏览完成
const percentGrainSize = 10; // 不同进度停留时长百分比粒度

const pageScrollPercentMixin = {
  data() {
    return {
      richTextTop: 0,
      richTextHeight: 0,
      visualHeight: 0,
      visualInitHeight: 0,
      visualMaxHeight: 0,
      percentDuration: {},
      percentDurationList: [],
      percentGrainList: [],
      pageUrl: '',
      scrollMonitor: false,
    };
  },
  computed: {
    ...mapGetters([
      'richTextScrollList',
    ]),
    surplusHeight() {
      if (this.richTextHeight && this.visualHeight > 0) {
        const surplusHeight = this.richTextHeight - this.visualHeight;
        return surplusHeight > 0 ? surplusHeight : 0;
      }
      return this.richTextHeight;
    },
    scrollBottom() {
      return this.surplusHeight < bottomDistance;
    },
    scrollPercent() {
      if (this.richTextHeight && this.visualHeight > 0) {
        const scrollPercent = ((this.visualHeight / this.richTextHeight) * 100).toFixed(2);
        return scrollPercent < 100 ? Number(scrollPercent) : 100;
      }
      return 0;
    },
    scrollMaxPercent() {
      if (this.richTextHeight && this.visualMaxHeight > 0) {
        const scrollMaxPercent = ((this.visualMaxHeight / this.richTextHeight) * 100).toFixed(2);
        return scrollMaxPercent < 100 ? Number(scrollMaxPercent) : 100;
      }
      return 0;
    },
  },
  watch: {
    scrollPercent(val) {
      this.savePercentDurationData();
      this.percentDuration.percent = val;
      this.percentDuration.enterTime = this.getCurrTime();
    },
  },
  methods: {
    getCurrTime() {
      return new Date().getTime();
    },
    savePercentDurationData() {
      if (this.percentDuration && this.percentDuration.percent) {
        this.percentDuration.leaveTime = this.getCurrTime();
        this.percentDurationList.push(this.percentDuration);
        this.percentDuration = {};
      }
    },
    onScrollHandler: throttle(function () {
      const { scrollTop } = document.scrollingElement;
      if (this.tabTop) this.tabSticky = scrollTop > this.tabTop;
      if (this.scrollMonitor) {
        const visualHeight = this.visualInitHeight + scrollTop;
        this.visualHeight = visualHeight < this.richTextHeight ? visualHeight : this.richTextHeight;
        if (this.visualHeight > this.visualMaxHeight) this.visualMaxHeight = this.visualHeight;
      }
    }, throttleTime),
    pageScrollHandler(rect) {
      if (rect) {
        this.richTextTop = parseInt(rect.top, 10);
        this.richTextHeight = parseInt(rect.height, 10);
        const { clientHeight } = document.scrollingElement;
        this.visualInitHeight = clientHeight - this.richTextTop;
        this.pageUrl = this.$route.fullPath;
        for (let i = 0; i < (100 / percentGrainSize) + 1; i++) {
          this.percentGrainList.push({
            limit: i * percentGrainSize,
            height: Number((i * percentGrainSize * 0.01 * this.richTextHeight).toFixed(2)),
          });
        }
      }
      if (!this.richTextTop || !this.richTextHeight) return;
      window.addEventListener('scroll', this.onScrollHandler);
      event.$on('pagehide', this.recordScrollHandler);
    },
    removeScrollHandler() {
      this.scrollMonitor = false;
      window.removeEventListener('scroll', this.onScrollHandler);
      event.$off('pagehide', this.recordScrollHandler);
    },
    recordScrollHandler() {
      if (!this.richTextHeight || this.visualHeight <= 0) return;
      this.savePercentDurationData();
      let totalDuration = 0;
      const percentDurationList = [];
      this.percentDurationList.map((item) => {
        item.duration = Number((item.leaveTime - item.enterTime).toFixed(2));
        for (let i = 0; i < this.percentGrainList.length - 1; i++) {
          const startPercent = this.percentGrainList[i].limit;
          const endPercent = this.percentGrainList[i + 1].limit;
          if (item.percent > startPercent && item.percent <= endPercent) {
            item.startPercent = startPercent;
            item.endPercent = endPercent;
          }
        }
        if (percentDurationList.length) {
          const lastPercentDurationItem = percentDurationList[percentDurationList.length - 1];
          // eslint-disable-next-line max-len
          if (lastPercentDurationItem.startPercent === item.startPercent && lastPercentDurationItem.endPercent === item.endPercent) {
            // eslint-disable-next-line max-len
            percentDurationList[percentDurationList.length - 1].stayDuration += item.duration;
          } else {
            percentDurationList.push({
              stayDuration: item.duration,
              startPercent: item.startPercent,
              endPercent: item.endPercent,
            });
          }
        } else {
          percentDurationList.push({
            stayDuration: item.duration,
            startPercent: item.startPercent,
            endPercent: item.endPercent,
          });
        }
        return item;
      });
      percentDurationList.forEach((item) => {
        totalDuration += Number(item.stayDuration);
      });
      let aboutVersion = 0;
      // eslint-disable-next-line prefer-destructuring
      if (this.product && this.product.aboutVersion) aboutVersion = this.product.aboutVersion;
      // eslint-disable-next-line prefer-destructuring
      if (this.vip && this.vip.aboutVersion) aboutVersion = this.vip.aboutVersion;
      // eslint-disable-next-line prefer-destructuring
      if (this.entity && this.entity.aboutVersion) aboutVersion = this.entity.aboutVersion;
      const richTextScrollList = [...this.richTextScrollList, {
        pageUrl: this.pageUrl,
        scrollBottom: this.scrollBottom,
        scrollPercent: this.scrollPercent,
        scrollMaxPercent: this.scrollMaxPercent,
        percentDurationList,
        totalDuration,
        aboutVersion,
      }];
      this.$store.dispatch('toggleRichTextScrollList', richTextScrollList);
      this.removeScrollHandler();
      window.scrollTo(0, 0);
    },
  },
  beforeDestroy() {
    this.recordScrollHandler();
  },
};

export default pageScrollPercentMixin;
